import api from './api'

/**
 * Server computes amount from cart line items (same rules as order + shipping).
 */
export async function createPaymentIntent({
  items,
  currency = 'ron',
  discount_amount = 0,
  metadata,
}) {
  const { data: res } = await api.post('/payments/create-intent', {
    items,
    currency,
    discount_amount,
    metadata,
  })
  return res
}

export async function getPaymentIntent(id) {
  const { data: res } = await api.get(`/payments/${encodeURIComponent(id)}`)
  return res
}
